import React, { useEffect, useState } from "react";
import CompanyLogo from "../../common/CompanyLogo";
import { FaRegBookmark } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Startups } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import Api_Instance from "../../api/Api_Instance";

const SaleOpportunity = () => {
  const navigate = useNavigate();
  const api = Api_Instance.unAuth();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const totalPages = Math.ceil(data?.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getApi = async () => {
    try {
      const res = await api("GET", Startups.GET_STARTUPS);
      const filteredData = res?.data?.data?.filter(item => item.status === true);
      setData(filteredData);
    } catch (error) {
      console.error("Error fetching startup data", error);
    }
  };

  useEffect(() => {
    getApi();
  }, []);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = data.slice(startIndex, startIndex + itemsPerPage);
  return (
    <>
      <CompanyLogo
        title={"High Growth Potential Startups"}
        subtitle={"High Growth Potential Startups"}
      />
      {currentData.length == 0 ? <div className="mt-5 flex justify-center">
        <button
          className="px-4 py-2 bg-primaryColor text-white rounded-lg"
        >
          Loading...
        </button>
      </div> :
        <div className="w-full  max-w-[1250px]      mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5">
            {currentData.map((item) => (
              <div
                className="border border-[#E4E4E4] rounded-lg bg-[#f9f8f8] [box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%)] p-3 lg:p-0"
                key={item.id}
              >
                <div className="relative">
                  <div className="px-3 py-1 bg-[#cc1e1e] text-white absolute z-10 top-7">
                    Gold
                  </div>
                  <button className="p-2 absolute top-7 right-4 rounded-md bg-white">
                    <FaRegBookmark className="text-black" />
                  </button>
                  <img
                    src={`${item?.business_pic}`}
                    alt="card_img"
                    className="rounded-t-md w-full h-40"
                  />
                </div>
                <div className="p-2 space-y-1">
                  <p className="text-text_color text-lg font-medium">
                    {item?.sector}
                  </p>
                  <div className="flex justify-between items-center text-primaryColor text-sm font-semibold">
                    <p>Seeking Investment</p>
                    <p>₹{item?.inventory}</p>
                  </div>
                  <div className="flex justify-between items-center text-subtext_color text-sm font-normal">
                    <p>Annual sale</p>
                    <p>₹{item?.annual_sales}</p>
                  </div>
                  {/* <div className="flex justify-between items-center text-subtext_color text-sm font-normal">
                    <p>Establishment year</p>
                    <p>{item?.year}</p>
                  </div>
                  <div className="flex justify-between items-center text-subtext_color text-sm font-normal">
                    <p>Employee count</p>
                    <p>{item?.employees}</p>
                  </div>
                  <div className="flex justify-between items-center text-subtext_color text-sm font-normal">
                    <p>Entity type</p>
                    <p>{item?.nature_entity}</p>
                  </div> */}
                  <div className="flex justify-between items-center text-subtext_color text-sm font-normal">
                    <p>Business type</p>
                    <p>{item?.business_type}</p>
                  </div>

                  <button
                    className="text-center p-2 rounded-md w-full bg-primaryColor text-white font-semibold mt-3"
                    onClick={() =>
                      navigate(`/startupdetails`, { state: { item: item } })
                    }
                  >
                    Contact Business

                  </button>
                </div>
              </div>
            ))}
          </div>
          {data.length > itemsPerPage && (
            <div className="flex justify-between mt-6">
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className={`px-4 py-2 rounded-md bg-primaryColor text-white font-medium transition duration-200 ease-in-out ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-opacity-80"
                  } shadow-md shadow-primaryColor/50`}
              >
                Previous
              </button>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 rounded-md bg-primaryColor text-white font-medium transition duration-200 ease-in-out ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-opacity-80"
                  } shadow-md shadow-primaryColor/50`}
              >
                Next
              </button>
            </div>
          )}

        </div>}
    </>
  );
};

export default SaleOpportunity;
